import { ErrorResponse } from '@models/error.response';
import { TranslateService } from '@ngx-translate/core';
import { MainComponent } from '../main/main.component';
import { of, from } from 'rxjs';
import { ActionType } from '@type/action.type';
import { AppConstant } from '@constants/app.constant';
import { NgForm } from '@angular/forms';
import { FormValidationUtil } from '@utils/form.validation';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Component, QueryList, ViewChild, ViewChildren } from '@angular/core';
import swal from 'sweetalert2';
import { switchMap, map, flatMap, filter, toArray, mergeMap, reduce } from 'rxjs/operators';
import { User } from '@app/models/user';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgSelectUtil } from '@app/utils/ng-select-utils';
import { OnepageTemplate } from '@app/models/onepage-template';
import { OnepageField, FieldType, OnepageFieldOption } from '@app/models/onepage-template-field';
import { ModulePathConstant } from '@app/constants/modulePath.constant';
import { CommonService } from '@app/services/common.service';
import { OnepageTemplateService } from '@app/services/onepage-template.service';
import { Deployment } from '@app/models/deployment';
import { DeploymentService } from '@app/services/deployment.service';
import { BsDatepickerConfig, BsLocaleService, ModalDirective } from 'ngx-bootstrap';
import { DeploymentProductInfo } from '@app/models/deployment-product-info';
import { OnepageProduct } from '@app/models/onepage-product';
import { ProductSelector } from '../product-selector/product-selector.component';
import { CommonResponse } from '@app/models/common-model';

@Component({
    templateUrl: './deployment-setup.component.html',
    styleUrls: ['./deployment-setup.component.scss']
})
export class DeploymentSetupComponent {
    @ViewChildren(NgSelectComponent) ngSelects: QueryList<NgSelectComponent>;
    selectAll = NgSelectUtil.selectAll
    @ViewChild('workflowForm', { static: false }) workflowForm: NgForm;
    @ViewChild('taskConfigSelector', { static: false }) taskConfigSelector: ProductSelector;
    isFieldError = FormValidationUtil.isFieldError;
    action: ActionType;
    loading: boolean = false;
    clickSave: boolean = false;
    isShowAdd:boolean = false;
    isShowUpdate:boolean = false;
    validUser: boolean = true;


    htmlTemplateFileOptions: string[]=['designA.png'];
    templateFieldLocationOptions: string[]=['default'];
    record: Deployment;
    selectedTemplateFile: any;

    deployDateRangeStart:Date;
    deployDateRangeEnd:Date;
    bsConfig: Partial<BsDatepickerConfig>;
    deployDescription: string;

    templateCode: string;
    templateId: string;
    theOnepageTemplate: OnepageTemplate;
    qrcodeUrl: string;
    qrcodeUrl_tc: string;
    qrcodeUrl_sc: string;
    tcUrl: string;
    enUrl: string;

    buttonFieldOptions: OnepageFieldOption[];
    productQuotaIsInvalid: boolean = false;
    isValidDateRange: boolean = true;

    constructor(
        private deploymentService: DeploymentService,
        private onepageTemplateService: OnepageTemplateService,
        private router: Router,
        private route: ActivatedRoute,
        private mainComponent: MainComponent,
        private commonService: CommonService,
        private translate: TranslateService,
        public appConstant: AppConstant) {
    }

    showInputAccordingly(theLangForField:string){
        if(!this.theOnepageTemplate){
            return this.record.publishLanguage=='EN_AND_TC'
             || !this.record.publishLanguage || this.record.publishLanguage==theLangForField;
        }
        return this.theOnepageTemplate.publishLanguage=='EN_AND_TC'
        || !this.theOnepageTemplate.publishLanguage || this.theOnepageTemplate.publishLanguage==theLangForField;
    }

    ngOnInit(): void {
        this.record = new Deployment();
        
        this.bsConfig = Object.assign({}, {
            // dateInputFormat: this.appConstant.dateFormatForBsDatePicker,
            dateInputFormat: this.appConstant.dateTimeFormat,
            withTimepicker: true,
            adaptivePosition: true,
            showWeekNumbers: false
        });

        // this.taskTypeOptions = [].concat(this.commonTaskTypeOptions)
        this.route.params
            .pipe(
                switchMap((params: Params) => {
                    this.loading = true;
                    if (params['id'] === 'new') {
                        this.action = 'CREATE';
                        this.isShowAdd = this.commonService.showAddButton(this.action,'PERM_ONEPAGE_TEMPLATE_CREATE');
                    } else {
                        let tmp = params['id'];
                        if(tmp.startsWith('ID_')){
                            this.templateId = tmp.substring(3);
                            this.action = 'TO_DEPLOY';
                        }else{
                            this.action = 'EDIT';
                            this.isShowUpdate = this.commonService.showUpdateButton(this.action,'PERM_ONEPAGE_TEMPLATE_UPDATE');
                        }
                    }
                    return of(params);
                }),
                switchMap((params: Params) => {
                    if(this.action == 'TO_DEPLOY') {
                        return this.onepageTemplateService.getButtonFieldIdList(this.templateId)
                            .pipe(
                                map(buttonFields => {
                                    this.buttonFieldOptions = buttonFields;
                                    return params;
                                })
                            );
                    }else{
                        return of(params);
                    }
                }),
                switchMap((params: Params) => {
                    if (this.action == 'CREATE') {
                        let form = new Deployment();
                        // let task = new OnepageField();
                        // form.onePageFields = [task];
                        return of(form);
                    } else if(this.action == 'TO_DEPLOY') {
                        return this.onepageTemplateService.get(this.templateId, '1')
                    } else {
                        return this.deploymentService.get(params['id'])
                    }
                })
            )
            .subscribe((workflowForm: any) => {
                if(this.action == 'TO_DEPLOY'){
                    this.record = new Deployment();
                    this.record.status='ENABLED';
                    this.theOnepageTemplate = workflowForm;
                    this.templateCode = this.theOnepageTemplate.onepageTemplateCode;
                    this.deployDescription = this.theOnepageTemplate.productName;
                    this.templateId = this.theOnepageTemplate.id;
                    this.record.merCode = this.theOnepageTemplate.merCode;
                    this.record.onepageTemplateCode = this.theOnepageTemplate.onepageTemplateCode;
                    this.record.deployedWithNewUrl = false;
                    this.record.onepageTemplateId = this.theOnepageTemplate.id;
                    this.record.description = this.theOnepageTemplate.productName+' Deployment';
                    this.record.quotaLeft = this.theOnepageTemplate.quotaLeft;
                    this.record.originalQuota = this.theOnepageTemplate.originalQuota;
                    this.record.startFrom = this.theOnepageTemplate.startFrom;
                    this.record.endTo = this.theOnepageTemplate.endTo;
                    this.record.useProductQuota = this.theOnepageTemplate.useProductQuota;
                    this.record.status = this.theOnepageTemplate.status;
                    
                    if(this.record.startFrom!=null){
                        var startd = new Date(this.record.startFrom);
                        this.record.startFrom = startd;
                        this.deployDateRangeStart = startd;
                    }
                    
                    if(this.record.endTo!=null){
                        var startd = new Date(this.record.endTo);
                        this.record.endTo = startd;
                        this.deployDateRangeEnd = startd;
                    }
                     

                    if(this.record.quotaLeft){
                        this.record.quota = this.record.quotaLeft;
                    }

                    this.changeQuotaType(this.record.useProductQuota);
                }else{
                    this.record = workflowForm;
                    if(!this.record.status){
                        this.record.status = 'ENABLED';
                    }
                    this.deployDateRangeStart = this.record.startFrom;
                    this.deployDateRangeEnd = this.record.endTo;
                    if(this.record.startFrom!=null){
                        var startd = new Date(this.record.startFrom);
                        this.record.startFrom = startd;
                        this.deployDateRangeStart = startd;
                    }
                    if(this.record.endTo!=null){
                        var startd = new Date(this.record.endTo);
                        this.record.endTo = startd;
                        this.deployDateRangeEnd = startd;
                    } 

                    if(this.record.url){
                        if(this.record.url.endsWith("_tc.html")){
                            this.qrcodeUrl = this.record.url.replace('/index_tc.html','/index_qrcode.png');
                            this.qrcodeUrl_tc  = this.record.url.replace('/index_tc.html','/index_qrcode_tc.png');
                            this.enUrl = this.record.url.replace('/index_tc.html','/index.html');
                            this.tcUrl = this.record.url;
                        }else{
                            this.qrcodeUrl = this.record.url.replace('/index.html','/index_qrcode.png');
                            this.qrcodeUrl_tc  = this.record.url.replace('/index.html','/index_qrcode_tc.png');
                            this.tcUrl = this.record.url.replace('/index.html','/index_tc.html');
                            this.enUrl = this.record.url;
                        }
                    }
                }
                // if (this.record.onePageFields && this.record.onePageFields.length > 0) {
                //     this.record.onePageFields.forEach(formTask => {
                //         // formTask._uiFlagId = formTask.workflowFormTaskId;
                //         // if (formTask.assignUsers) {
                //         //     formTask._selectedUsername = formTask.assignUsers.split(AppConstant.USER_TASK_ASSIGN_NAME);
                //         //     formTask._selectedTaskType = formTask.taskType;
                //         // }
                //     })
                // }
                // if (this.record.fieldType == 'COMPANY') {
                //     this.taskTypeOptions = this.taskTypeOptions.concat(this.companyTaskTypeOptions);
                // }
                this.loading = false;
            });

    }

    changeQuotaType(useProductQuota:boolean){
        this.record.useProductQuota = useProductQuota
        if(useProductQuota && this.buttonFieldOptions && (!this.record.productInfos || this.record.productInfos.length==0)){
            this.record.productInfos = [];

            for(var i=0; i<this.buttonFieldOptions.length; i++){
                var onepageFieldOption = this.buttonFieldOptions[i];
                let formTask = new DeploymentProductInfo();
                formTask.productCode = onepageFieldOption.productCode;
                formTask.productName = onepageFieldOption.productName;
                formTask.relatingButtonFieldId = onepageFieldOption.fieldId;
                formTask.relatingButtonFieldOption = onepageFieldOption;
                if(onepageFieldOption.refQuota){
                    formTask.quota = onepageFieldOption.refQuota;
                }
                this.record.productInfos.push(formTask);
            }

        }
    }

    isInValidProductQuota(){
        if(!this.record.useProductQuota){
            return false;
        }

        let res = !this.record.productInfos || (this.record.productInfos && this.record.productInfos.length==0);
        this.productQuotaIsInvalid = res;
        return res;
    }

    
    __enabledDeployment(){

        var isDisable = false;
        if(this.record.status=='ENABLED'){
           isDisable = true;
        }
        
        this.mainComponent.enableLoadingMask();
        this.loading = true;

        this.deploymentService.disable(this.record.id, isDisable).subscribe((response:CommonResponse)=>{

            console.log(JSON.stringify(response));
            if(response.content.status=='SUCCESS'){

                this.mainComponent.disableLoadingMask();
                this.loading = false;

                this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_DEPLOYMENT_PATH]);

                this.translate.get(ModulePathConstant.ONEPAGE_TEMPLATE_DEPLOYMENT)
                    .pipe(
                        switchMap(typeStr => this.translate.get(AppConstant.HAS_BEEN_UPDATED, { type: typeStr }))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'success',
                            title: res
                        });
                    });
            }
            
        });
    }


    enabledDeployment(){
         
         let instance = this;
         let txt = this.record.status=='ENABLED'?'CONFIRM_TO_DISENABLE_THE_DEPLOYMENT':'CONFIRM_TO_ENABLE_THE_DEPLOYMENT';
         
         this.translate.get([txt,
         'CONFIRM',
         'CANCEL'])
         .subscribe(res => {
             swal.fire({
                 text: res[txt],
                 type: 'warning',
                 showCancelButton: true,
                 cancelButtonText: res.CANCEL,
                 confirmButtonText: res.CONFIRM
             }).then(result => {
                 if (result.value) {
                        instance.loading = false;
                        instance.__enabledDeployment();
                 }
             });
         });
 


    }

    

    isValidateInput(): boolean{

        if(this.deployDateRangeStart && this.deployDateRangeEnd){
            var d1 = new Date(this.deployDateRangeStart);
            var d2 = new Date(this.deployDateRangeEnd);
            if(d1<d2){
                this.isValidDateRange = true;
            }else{
                this.isValidDateRange = false;
                return false;
            }
        }

        return true;
    }

    addTask() {
        let formTask = new DeploymentProductInfo();
        if(!this.record.productInfos){
            this.record.productInfos=[];
        }
        this.record.productInfos.push(formTask);
    }

    remove(task: DeploymentProductInfo) {
        var index = this.record.productInfos.indexOf(task);
        this.record.productInfos.splice(index, 1);
    }

    onFieldLocationChange(task: OnepageField, taskType: string) {
        
        task.location = taskType;

    }
 

    isEmptyTask(): boolean {
        let result = true;//this.record.onePageFields && (this.record.onePageFields.length == 0);
        return result;
    }

    isEmptyTaskConfig(formTask: OnepageField): boolean {
        // this task type no need to check the config.
        // if (formTask && formTask.taskType == 'COMPANY_REGISTER_GEN') {
        //     return false;
        // }
        // if (this.record.onePageFields.find(t => t == formTask) != null) {
        //     return false;//formTask.taskConfig == null;
        // }
        return false;
    }

    checkDateRange(): boolean{
        if(!this.deployDateRangeEnd || !this.deployDateRangeStart){
            this.isValidDateRange = false;
            return false;
        }
        return true;
    }


    save(): void {

        if(this.record.deployedWithNewUrl){

            let txt = 'CONFIRM_TO_DEPLOY_WITH_NEW_URL';
            let instance = this;
            this.translate.get([txt,
            'CONFIRM',
            'CANCEL'])
            .subscribe(res => {
                swal.fire({
                    text: res[txt],
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: res.CANCEL,
                    confirmButtonText: res.CONFIRM
                }).then(result => {
                    if (result.value) {
                            instance.executeSave();
                    }
                });
            });

        }else{
            this.executeSave();
        }

      
    }
 
    private executeSave(): void{
        this.clickSave = true;
        //check form for just clicking save without any input
        for (let key of Object.keys(this.workflowForm.controls)) {
            this.workflowForm.controls[key].markAsDirty();
        }

        this.checkDateRange();

        if(this.record.useProductQuota && this.productQuotaIsInvalid){
            return;
        }
        if(!this.isValidDateRange){
            return;
        }


        if (!this.validUser) {
            return;
        }



        if (this.workflowForm.valid) {
            // this.record.templateFileName = MapObjectUtil.setOtherLocaleValueAsCurrentLocale(this.record.templateFileName,'en')
            switch (this.action) {
                case 'CREATE':
                    this.create();
                    break
                case 'EDIT':
                    this.update();
                    break;
                case 'TO_DEPLOY':
                        this.todeploy();
                        break;
            }
        }
    }

 
    private todeploy(): void {

        this.mainComponent.enableLoadingMask();
        this.loading = true;
        this.record.startFrom = this.deployDateRangeStart;
        this.record.endTo = this.deployDateRangeEnd;
        this.record.startFromDateValue = (this.deployDateRangeStart==null)?null:
                (!this.deployDateRangeStart.getTime?(Number.parseFloat(this.deployDateRangeStart+'')):this.deployDateRangeStart.getTime());
        this.record.endToDateValue = (this.deployDateRangeEnd==null)?null:
        (!this.deployDateRangeEnd.getTime?(Number.parseFloat(this.deployDateRangeEnd+'')):this.deployDateRangeEnd.getTime());

        this.deploymentService.insert(this.record)
            .subscribe(record => {
                this.record = record;
                this.mainComponent.disableLoadingMask();
                this.loading = false;

                if(this.record.url){
                    if(this.record.url.endsWith("_tc.html")){
                        this.qrcodeUrl = this.record.url.replace('/index_tc.html','/index_qrcode.png');
                        this.qrcodeUrl_tc  = this.record.url.replace('/index_tc.html','/index_qrcode_tc.png');
                        this.enUrl = this.record.url.replace('/index_tc.html','/index.html');
                        this.tcUrl = this.record.url;
                    }else{
                        this.qrcodeUrl = this.record.url.replace('/index.html','/index_qrcode.png');
                        this.qrcodeUrl_tc  = this.record.url.replace('/index.html','/index_qrcode_tc.png');
                        this.tcUrl = this.record.url.replace('/index.html','/index_tc.html');
                        this.enUrl = this.record.url;
                    }
                }

                this.action = 'DEPLOY_DONE';

            },
                (error: ErrorResponse) => {
                    this.mainComponent.disableLoadingMask();
                    this.loading = false;


                    from(error.errors)
                        .pipe(
                            mergeMap(error => this.translate.get(error.errorCode)),
                            reduce((acc, value) => acc + value + '<br/>', '')
                        )
                        .subscribe(msg => {

                            this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                                .pipe(
                                    switchMap(typeStr => this.translate.get(AppConstant.FAIL_TO_UPDATE, { type: typeStr }))
                                )
                                .subscribe(title => {
                                    swal.fire({
                                        type: 'error',
                                        title: title,
                                        html: msg
                                    });
                                });
                        });
                })

    }

    private create(): void {

        this.mainComponent.enableLoadingMask();
        this.loading = true;
        this.record.startFrom = this.deployDateRangeStart;
        this.record.endTo = this.deployDateRangeEnd;
        this.record.startFromDateValue = this.deployDateRangeStart==null?null:this.deployDateRangeStart.getTime();
        this.record.endToDateValue = this.deployDateRangeEnd==null?null:this.deployDateRangeEnd.getTime();
        this.record.status = 'ENABLED';

        this.deploymentService.insert(this.record)
            .subscribe(() => {
                this.mainComponent.disableLoadingMask();
                this.loading = false;

                this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_DEPLOYMENT_PATH]);

                this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                    .pipe(
                        switchMap(typeStr => this.translate.get(AppConstant.HAS_BEEN_ADDED, { type: typeStr }))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'success',
                            title: res
                        });
                    });
            },
                (error: ErrorResponse) => {
                    this.mainComponent.disableLoadingMask();
                    this.loading = false;
                    from(error.errors)
                        .pipe(
                            mergeMap(error => this.translate.get(error.errorCode)),
                            reduce((acc, value) => acc + value + '<br/>', '')
                        )
                        .subscribe(msg => {

                            this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                                .pipe(
                                    switchMap(typeStr => this.translate.get(AppConstant.FAIL_TO_ADD, { type: typeStr }))
                                )
                                .subscribe(title => {
                                    swal.fire({
                                        type: 'error',
                                        title: title,
                                        html: msg
                                    });
                                });

                        });
                });
    }

    private update(): void {

        this.mainComponent.enableLoadingMask();
        this.loading = true;
        this.record.startFrom = this.deployDateRangeStart;
        this.record.endTo = this.deployDateRangeEnd;
        this.record.startFromDateValue = this.deployDateRangeStart==null?null:this.deployDateRangeStart.getTime();
        this.record.endToDateValue = this.deployDateRangeEnd==null?null:this.deployDateRangeEnd.getTime();

        this.deploymentService.update(this.record)
            .subscribe(record => {
                this.record = record;
                this.mainComponent.disableLoadingMask();
                this.loading = false;

                this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_DEPLOYMENT_PATH]);

                this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                    .pipe(
                        switchMap(typeStr => this.translate.get(AppConstant.HAS_BEEN_UPDATED, { type: typeStr }))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'success',
                            title: res
                        });
                    });

            },
                (error: ErrorResponse) => {
                    this.mainComponent.disableLoadingMask();
                    this.loading = false;


                    from(error.errors)
                        .pipe(
                            mergeMap(error => this.translate.get(error.errorCode)),
                            reduce((acc, value) => acc + value + '<br/>', '')
                        )
                        .subscribe(msg => {

                            this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                                .pipe(
                                    switchMap(typeStr => this.translate.get(AppConstant.FAIL_TO_UPDATE, { type: typeStr }))
                                )
                                .subscribe(title => {
                                    swal.fire({
                                        type: 'error',
                                        title: title,
                                        html: msg
                                    });
                                });
                        });
                })

    }

    cancel(): void {
        this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_DEPLOYMENT_PATH]);
    }
 

    selectOneField(formTask: DeploymentProductInfo){

        if(formTask.relatingButtonFieldOption){
            console.log(">>>"+formTask.relatingButtonFieldOption.productCode);
            formTask.relatingButtonFieldId = formTask.relatingButtonFieldOption.fieldId;
            formTask.productCode = formTask.relatingButtonFieldOption.productCode;
            formTask.productName = formTask.relatingButtonFieldOption.productName;
        }
    }

     temp: number;
    switchNewUrl(){
        if(this.record.deployedWithNewUrl){
            this.temp = this.record.quota;
            this.record.quota = null;
        }else{
            this.record.quota = this.temp;
        }
    }

}
